import { render, staticRenderFns } from "./Permissoes.vue?vue&type=template&id=744c5493"
import script from "./Permissoes.vue?vue&type=script&lang=js"
export * from "./Permissoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports